<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="关联孔号：" prop="hole_code_relation">
                <el-input v-model="model.hole_code_relation"></el-input>
            </el-form-item>
            <el-form-item label="关联方式：" prop="relation_type">
                <el-select clearable v-model="model.relation_type" placeholder="请选择">
                    <el-option v-for="item in enuObj('report_relation_type')" :key="'relation_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'reportRelationEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                report_id: '',
                hole_id: '',
                hole_code: '',
                segment_no: '',
                hole_id_relation: '',
                hole_code_relation: '',
                relation_type: '',
                relation_time: '',
            },
            getObj:{
                url:'/api/admin/reportrelation/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['report_relation_type'],
            rules: {
                hole_code_relation: [
                    {required: true, message: '关联孔号不能为空', trigger: 'blur'}
                ],
                relation_type: [
                    {required: true, message: '关联类型不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    props: {
        report_id: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/reportrelation/save'
                    }
                    this.model.report_id = this.report_id
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>